// Explicit icon registry so the visual-edits babel plugin can trace props
// without choking on `import * as X from 'lucide-react'` namespace imports.
import {
  Anchor,
  ArrowRight,
  BookOpen,
  CalendarDays,
  Check,
  ChevronDown,
  ChevronRight,
  ClipboardCheck,
  Cog,
  Compass,
  Crown,
  Dot,
  Fish,
  Key,
  KeyRound,
  Landmark,
  LifeBuoy,
  MapPin,
  Radar,
  Sailboat,
  Shield,
  ShieldCheck,
  Ship,
  ShoppingBag,
  SprayCan,
  Sun,
  Star,
  TrendingUp,
  Truck,
  UserCheck,
  Users,
  UtensilsCrossed,
  Warehouse,
  Waves,
  Wrench,
  Zap,
} from 'lucide-react';

const ICONS = {
  Anchor,
  ArrowRight,
  BookOpen,
  CalendarDays,
  Check,
  ChevronDown,
  ChevronRight,
  ClipboardCheck,
  Cog,
  Compass,
  Crown,
  Dot,
  Fish,
  Key,
  KeyRound,
  Landmark,
  LifeBuoy,
  MapPin,
  Radar,
  Sailboat,
  Shield,
  ShieldCheck,
  Ship,
  ShoppingBag,
  SprayCan,
  Sun,
  Star,
  TrendingUp,
  Truck,
  UserCheck,
  Users,
  UtensilsCrossed,
  Warehouse,
  Waves,
  Wrench,
  Zap,
};

export function getIcon(name, fallback = Dot) {
  return ICONS[name] || fallback;
}

export default ICONS;
